// Intake Questions Feature Module (Story 7.6)

export { IntakeQuestionsConfig } from './IntakeQuestionsConfig';
export {
  useIntakeQuestions,
  useCreateIntakeQuestion,
  useBulkUpdateIntakeQuestions,
  useDeleteIntakeQuestion,
  useUpdateIntakeSettings,
} from './useIntakeQuestions';
export type { IntakeQuestionApi } from './types';
